// src/components/Seo.tsx
type SeoProps = {
  jsonLd?: Record<string, unknown> | null;
};

export default function Seo({ jsonLd }: SeoProps) {
  // « < » échappé en < (JSON valide) : une valeur contenant « </script> » ne peut
  // pas fermer la balise et injecter du HTML.
  return jsonLd ? (
    <script type="application/ld+json">
      {JSON.stringify(jsonLd).replace(/</g, "\\u003c")}
    </script>
  ) : null;
}
